import AntennaIcon from "./ico_antenna.png";
import ArrowIcon from "./ico_arrow.png";
import BatteryIcon from "./ico_battery.png";
import IcoCaution from "./ico_caution.png";
import BatteryEmptyIcon from "./ico_battery_empty.png";
import ButtonCrossIcon from "./btn_cross.png";
import ButtonNavIcon from "./btn_navbar.png";
import CopyIcon from "./ico_copy.png";
import CrossIcon from "./ico_cross.png";
import DownloadIcon from "./ico_download.png";
import DropdownIcon from "./dropdown_nav.svg";
import SendIcon from "./ico_send.png";
import SettingIcon from "./ico_setting.png";
import TipIcon from "./ico_tips.png";
import TrashIcon from "./ico_trash.png";
import TrashRedIcon from "./ico_trash_r.png";

export {
  AntennaIcon,
  ArrowIcon,
  BatteryIcon,
  IcoCaution,
  BatteryEmptyIcon,
  ButtonCrossIcon,
  ButtonNavIcon,
  CopyIcon,
  CrossIcon,
  DownloadIcon,
  DropdownIcon,
  SendIcon,
  SettingIcon,
  TipIcon,
  TrashIcon,
  TrashRedIcon,
};
